import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import Branch from 'src/app/model/branch/branch';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { BranchControllerRequestService } from './branch-controller-request.service';

@Injectable({
  providedIn: 'root'
})
export class BranchChoicesService {
  private branchChoices = new BehaviorSubject<Branch[]>([]);

  constructor(
    private branchControllerRequestService: BranchControllerRequestService
  ) {}

  public updateBranchChoices(): void {
    this.branchControllerRequestService
      .getPaged()
      .then((page: ProperPageResult<Branch>) => {
        this.branchChoices.next(page.items);
      });
  }

  public getBranchChoicesSubscribable(): Observable<Branch[]> {
    return this.branchChoices;
  }
}
